import { createSelector } from "@reduxjs/toolkit";
//#region src/redux/transient/selectors.ts
var pickTransientState = () => (store) => store.transient;
var selectTransient = (key) => createSelector([pickTransientState()], (transientState) => {
	return transientState.transients.find((transient) => transient.key === key);
});
//#endregion
export { pickTransientState, selectTransient };

//# sourceMappingURL=selectors.js.map